import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.eventTimeZone.fields.id'),
  },
  {
    name: 'code',
    label: i18n('entities.eventTimeZone.fields.code'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.eventTimeZone.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.eventTimeZone.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
